module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-gift-ac9ef95f599b129e75a36a681cfcdee8.png";